import React from "react";
import "./index.scss";
import FinancialYearCalendar from "../../../../components/financial-year-calendar";
import { trainingDetails } from "../../../../components/financial-year-calendar/helper";

const ScheduledTrainings = () => {

  return (
    <div>
        <FinancialYearCalendar year={2024} trainings={trainingDetails} />
    </div>
  );
};

export default ScheduledTrainings;
